import Button from 'components/common/Button';
import Link from 'next/link';
import Heading from '@/components/common/Heading';
import { LandingCardBase } from '../landing/LandingCardBase';

export const SystemSelector = () => {
  return (
    <>
      <LandingCardBase className='mb-5 px-0 py-8 md:p-0'>
        <div className='flex w-full flex-col items-stretch justify-between gap-y-16 md:flex-row md:items-center'>
          <div className='order-1 w-full p-7 md:w-5/12 md:p-16'>
            <div className='flex flex-col items-start justify-start gap-y-5 md:gap-y-8'>
              <Heading size={5}>Need help choosing a system?</Heading>
              <Heading size={3}>
                Try our system selector for your DIY&reg;
              </Heading>
              <Link href={{ pathname: '/system-selector' }}>
                <Button>Configure Now</Button>
              </Link>
            </div>
          </div>
          <div className='order-2 flex w-full pl-16 md:hidden'>
            <img
              src='https://res.cloudinary.com/dbkbadq4w/image/upload/q_auto/f_auto/system-selector-mobile-0125-658x256_z4uypn'
              alt='Try our system selector for your DIY&reg;'
              title='Try our system selector for your DIY&reg;'
              className='h-auto w-full'
            />
          </div>
          <div className='order-2 hidden w-full md:ml-auto md:flex md:w-7/12'>
            <img
              src='https://res.cloudinary.com/dbkbadq4w/image/upload/q_auto/f_auto/web/mrcool.com/5th%20Gen%20DIY/Page%20Assets/Ipad_hand_cvh5cp'
              alt='Try our system selector for your DIY&reg;'
              title='Try our system selector for your DIY&reg;'
              className='h-auto w-full'
            />
          </div>
        </div>
      </LandingCardBase>
    </>
  );
};
